/**
 * 집사 — 이 앱의 구독제.
 *
 * ⚠️ **지금은 파는 자리가 없다.** 등급을 고르는 화면도 결제도 없고, 가입하면
 * 전부 `none`으로 시작한다. 등급을 올리는 유일한 길은 **관리자 승인**이다.
 *
 * 그래도 **상한은 살아 있다.** 나중에 팔 것이기 때문이고, 그때 가서 붙이면
 * 이미 상한 없이 주소를 늘려둔 사람들이 생겨 되돌릴 수 없다.
 *
 * 등급별로 무엇이 달라지는지와 결제를 붙일 때 필요한 것은 `docs/plan.md`.
 */

export const PLANS = ["none", "house", "mansion"] as const;

export type Plan = (typeof PLANS)[number];

export function isPlan(value: string): value is Plan {
  return (PLANS as readonly string[]).includes(value);
}

/**
 * 등급마다 쓸 수 있는 **주소 개수**.
 *
 * `docs/architecture.md` §1의 "무제한 identity"와 부딪히는 것처럼 보이지만
 * 그렇지 않다. 그 문서가 말하는 것은 **주소를 몇 개 만들든 인프라 비용이 0**
 * 이라는 것이고 그건 그대로다. 여기서 세는 것은 파는 단위다.
 */
export const ADDRESS_LIMIT: Record<Plan, number> = {
  none: 1,
  house: 3,
  mansion: 5,
};

/** 등급마다 **매달** 들어오는 캣닙. 아직 아무도 쓰지 않는다(AI 기능이 없다). */
export const MONTHLY_CATNIP: Record<Plan, number> = {
  none: 0,
  house: 250,
  mansion: 5_000,
};
